import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import PlayerAvatar from './ui/PlayerAvatar';

/**
 * Antes de formar os times: pote (1 = melhores … 6) de quem não tem avaliação da pelada nem ranking do torneio.
 * `jogadores`: [{ id, nome, convidado }] (resposta POTE_NECESSARIO da API); `onConfirmar({ [id]: pote })`.
 */
const PotesDialog = ({ jogadores, enviando, onConfirmar, onFechar }) => {
  const [potes, setPotes] = useState({});

  useEffect(() => {
    setPotes({});
  }, [jogadores]);

  const completos = (jogadores || []).every((j) => potes[j.id]);

  return (
    <Dialog open={Boolean(jogadores && jogadores.length)} onClose={enviando ? undefined : onFechar} fullWidth maxWidth="xs">
      <DialogTitle>Qual o pote destes jogadores?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Eles ainda não têm avaliação da pelada nem ranking do torneio. Pote 1 = os melhores, pote 6 = os mais fracos.
        </Typography>
        <Stack spacing={2}>
          {(jogadores || []).map((jogador) => (
            <Stack key={jogador.id} spacing={1}>
              <Stack direction="row" spacing={1} alignItems="center">
                <PlayerAvatar name={jogador.nome} size={28} />
                <Typography fontWeight={600} noWrap>{jogador.nome}</Typography>
                {jogador.convidado && <Typography variant="caption" color="text.secondary">convidado</Typography>}
              </Stack>
              <ToggleButtonGroup
                exclusive
                fullWidth
                size="small"
                value={potes[jogador.id] || null}
                onChange={(e, pote) => pote && setPotes((atual) => ({ ...atual, [jogador.id]: pote }))}
                aria-label={`Pote de ${jogador.nome}`}
              >
                {[1, 2, 3, 4, 5, 6].map((pote) => (
                  <ToggleButton key={pote} value={pote} sx={{ fontWeight: 700 }}>{pote}</ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar} disabled={enviando}>Cancelar</Button>
        <Button variant="contained" onClick={() => onConfirmar(potes)} disabled={!completos || enviando}>
          Formar os times
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PotesDialog;
